import React, { useRef, useEffect } from 'react';
import './Boots.scss';
import video from '../../../../assets/future/boots/future_boots_mobile.mp4';
import poster from '../../../../assets/future/boots/future_boots_mobile_poster.png';
import videomovD from '../../../../assets/future/boots/future_boots_desktop.mov';
import videoD from '../../../../assets/future/boots/future_boots_desktop.webm';
import posterD from '../../../../assets/future/boots/future_boots_desktop_poster.png';
import HighlightedCopy from '../../../Common/CopyBlocks/HighlightedCopy';

function FutureBoots({ screenWidth }) {
  const bootsRef = useRef();
  const videoDRef = useRef();
  const videoMRef = useRef();
  const highlight1 = useRef();
  const highlight2 = useRef();
  const copyData = [
    {
      ref: highlight1,
      copy: 'Mars exploration will require a spacesuit designed especially for Martian terrain — including boots that can handle the planet’s rocky landscape, potentially toxic dust, and variable surface temperatures. '
    },
    {
      ref: highlight2,
      copy: 'One future-looking design involves boots that vibrate to warn spacewalkers about obstacles ahead.'
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry['isIntersecting'] === true) {
            if (entry['intersectionRatio'] > 0.7) {
              if (screenWidth > 480) {
                videoDRef.current.play();
              } else {
                videoMRef.current.play();
              }
            }
          }
        });
      },
      { threshold: [0, 0.7] }
    );
    observer.observe(bootsRef.current);
  }, [screenWidth]);
  return (
    <section className="boots boots-future">
      <div className="boots__animation boots__animation-artemis" ref={bootsRef}>
        <video
          muted={true}
          playsInline
          preload="auto"
          ref={videoDRef}
          className="boots__animation__video boots__animation__video-desktop"
          poster={posterD}
        >
          <source src={videomovD} type="video/quicktime" />
          <source src={videoD} type="video/webm" />
        </video>

        <video
          muted={true}
          playsInline
          preload="auto"
          ref={videoMRef}
          className="boots__animation__video boots__animation__video-mobile"
          poster={poster}
        >
          <source src={video} type="video/mp4" />
        </video>
      </div>
      <div className="boots__text boots__text-artemis">
        <HighlightedCopy copyData={copyData} />
      </div>
    </section>
  );
}

export default FutureBoots;
